import React from 'react'
import { Panel, FormControl, Button } from 'react-bootstrap'
import { I18n } from 'react-redux-i18n'
import Select from 'react-select'
import ServiceSearchSelect from '../service/ServiceSearchSelect'
import { checkIfAnyGrantedByGivenAuth } from '../../modules/authService'
import { archivedDataAccess } from '../../modules/accessList'
import DateTime from 'react-datetime'
import moment from 'moment'

const ServiceTxnTableFilterPanel = ({
  isShow,
  filter,
  onFilterChange,
  onClearFilter,
  auth,
}) => {
  const fieldsLabel = I18n.t('serviceTxnPage.fields')
  const startDateValid = (current) => {
    if (filter.serviceDateTimeEnd)
      return current
        .startOf('day')
        .isBefore(filter.serviceDateTimeEnd.endOf('day'))
    return true
  }

  const endDateValid = (current) => {
    if (filter.serviceDateTimeStart)
      return current
        .endOf('day')
        .isAfter(filter.serviceDateTimeStart.startOf('day'))
    return true
  }

  return (
    <Panel collapsible expanded={isShow}>
      <div className="p-4">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-4">
          {/* Main Filter Section */}
          <div className="lg:col-span-10">
            {/* Row 1: Service, Flight Number, Main Pax, Status */}
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 mb-4">
              <div>
                <ServiceSearchSelect
                  value={filter.service}
                  placeholder={fieldsLabel.service}
                  onChange={(value) => onFilterChange('service', value)}
                />
              </div>
              <div>
                <FormControl
                  type="text"
                  value={filter.flightNumber || ''}
                  onChange={(e) =>
                    onFilterChange('flightNumber', e.currentTarget.value)
                  }
                  placeholder={fieldsLabel.flightNumber}
                />
              </div>
              <div>
                <FormControl
                  type="text"
                  value={filter.mainPax || ''}
                  onChange={(e) =>
                    onFilterChange('mainPax', e.currentTarget.value)
                  }
                  placeholder={fieldsLabel.mainPax}
                />
              </div>
              <div>
                <Select
                  value={filter.status}
                  onChange={(value) => onFilterChange('status', value)}
                  placeholder={fieldsLabel.status}
                  simpleValue
                  options={statusOptions}
                />
              </div>
            </div>

            {/* Row 2: Confirmation Number, Date Range */}
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
              <div>
                <FormControl
                  type="text"
                  value={filter.confirmationNumber || ''}
                  onChange={(e) =>
                    onFilterChange('confirmationNumber', e.currentTarget.value)
                  }
                  placeholder={fieldsLabel.confirmationNumber}
                />
              </div>
              <div>
                <DateTime
                  value={filter.serviceDateTimeStart}
                  onChange={(value) => {
                    if (value && !moment.isMoment(value)) return
                    onFilterChange('serviceDateTimeStart', value)
                  }}
                  dateFormat="DD-MM-YYYY"
                  timeFormat={false}
                  isValidDate={startDateValid}
                  inputProps={{
                    placeholder: fieldsLabel.serviceDateTimeStart,
                  }}
                />
              </div>
              <div>
                <DateTime
                  value={filter.serviceDateTimeEnd}
                  onChange={(value) => {
                    if (value && !moment.isMoment(value)) return
                    onFilterChange('serviceDateTimeEnd', value)
                  }}
                  dateFormat="DD-MM-YYYY"
                  timeFormat={false}
                  isValidDate={endDateValid}
                  inputProps={{ placeholder: fieldsLabel.serviceDateTimeEnd }}
                />
              </div>
              <div>
                <Select
                  value={filter.createByKiosk}
                  onChange={(value) => onFilterChange('createByKiosk', value)}
                  placeholder={fieldsLabel.createByKiosk || 'Created On'}
                  simpleValue
                  options={createByKioskOptions}
                />
              </div>
            </div>
          </div>

          {/* Actions Section */}
          <div className="lg:col-span-2 flex flex-col gap-4">
            <div>
              <Button className="w-full" onClick={onClearFilter}>
                <span className="glyphicon glyphicon-trash" /> Clear Filter
              </Button>
            </div>
            {auth && checkIfAnyGrantedByGivenAuth(auth, archivedDataAccess) && (
              <div className="flex justify-center items-center">
                <label className="flex items-center gap-2 cursor-pointer">
                  <input
                    type="checkbox"
                    checked={filter.searchArchived || false}
                    onChange={(e) =>
                      onFilterChange('searchArchived', e.target.checked)
                    }
                  />
                  <span>Search Archived</span>
                </label>
              </div>
            )}
          </div>
        </div>
      </div>
    </Panel>
  )
}

export default ServiceTxnTableFilterPanel

const createByKioskOptions = [
  { label: 'ALL', value: '' },
  { label: 'KIOSK', value: 'true' },
  { label: 'RESERVATION', value: 'false' },
]

const statusOptions = [
  { label: 'PROCESSING', value: 'processing' },
  { label: 'COMPLETED', value: 'completed' },
  { label: 'MISSED CASE', value: 'missedCase' },
  { label: 'NOSHOW', value: 'noShow' },
  { label: 'CANCELED', value: 'canceled' },
]
